import { IPublicClientApplication } from '@azure/msal-browser';
import { ApiEndpointCallStatesStore } from '../api-endpoint-call-states-store';
import { FetchContext } from '../fetch-context';
import { promiseWithObservableState } from '../promise-with-observable-state';
import { withApiAccessToken } from '../with-api-access-token';
import { getAwardNominationSummaries, getCountryAwardNominationSummaries } from './index';

export const createNominationSummariesApiEndpoints = (
  fetchContext: FetchContext,
  apiEndpointCallStates: ApiEndpointCallStatesStore,
) => ({
  getAwardNominationSummaries: (instance: IPublicClientApplication, awardId: number, searchText?: string) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => getAwardNominationSummaries(fetchContext, awardId, searchText, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('getAwardNominationSummaries', isInFlight);
    },
  ),
  getCountryAwardNominationSummaries: (instance: IPublicClientApplication, programId: number, countryId: number, searchText?: string) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => getCountryAwardNominationSummaries(fetchContext, programId, countryId, searchText, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('getCountryAwardNominationSummaries', isInFlight);
    },
  ),
});
